import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

// BOT_CREATE no tiene permiso VIEW propio en el RBAC: se valida contra
// el permiso de detalle/configuración de bot (bot_detail).
function CreateBot (){
  const {user} = useUser()
  let view = contentLayout[modules.BotCreate]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.BotDetail.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.BotList}></Index>
 )
}

export default CreateBot
